












import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import StockInFastMulti from "@/modules/warehouses/StockInFast/index.vue";
import StockInNormal from "@/modules/warehouses/StockIn/StockInNormal/index.vue";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
  name: "StockIn",
  components: {
    StockInNormal,
    StockInFastMulti
  }
})
export default class extends mixins(CommonMixin) {
  current = [this.hasPermission(RoleDeclare.ROLE_CAN_STOCK_IN) ? 'StockInNormal' : 'StockInFastMulti'];
  menuItem = {
    stockIn: 'StockInNormal',
    stockInFast: 'StockInFastMulti'
  }

  stockComponentSelected = this.hasPermission(RoleDeclare.ROLE_CAN_STOCK_IN) ? 'StockInNormal' : 'StockInFastMulti';

  selectMenu({key}) {
    if (!this.hasPermission(RoleDeclare.ROLE_CAN_STOCK_IN) && key === this.menuItem.stockIn
        || !this.hasPermission(RoleDeclare.ROLE_CAN_STOCK_IN_FAST) && key === this.menuItem.stockInFast) {
      this.$notification.warn({
        message: "Từ chối truy cập",
        description: "Bạn không có quyền truy cập"
      })
      return;
    } else {
      this.stockComponentSelected = key;
    }
  }
}
